import { render, staticRenderFns } from "./ApprovalFormModal.vue?vue&type=template&id=6c601988&scoped=true&"
import script from "./ApprovalFormModal.vue?vue&type=script&lang=js&"
export * from "./ApprovalFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c601988",
  null
  
)

export default component.exports